<ng-container *ngIf="tooltipTitle; else iconOnly">
  <i
    [ngClass]="[iconClass, customClass]"
    kendoTooltip
    [position]="tooltipPosition"
    [title]="tooltipTitle"
    [tooltipClass]="tooltipClass"
    [style.color]="iconColor"
  ></i>
</ng-container>

<ng-template #iconOnly>
  <i [ngClass]="[iconClass, customClass]" [style.color]="iconColor"></i>
</ng-template>
